

import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavImg from "./images/icons/nav.png";
import minus from "./images/icons/minus-sign.png";
import userImg from "./images/logout.png";
import u from "./images/profile.png";
import settings from "./images/ViewDashboard/settings.png";
import notifi from "./images/ViewDashboard/notifi.png";
import logoutImg from "./images/power1.png";
import clock from "./images/icons/clock.png";
import "./css/TableReg.css";
import "./css/SherDineNav.css";
import io from 'socket.io-client';
import { DBContext } from './DBContext'
import { DineContext } from './DineContext'
import axios from 'axios'
import noImage from './images/icons/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg'
import stock from './images/icons/In stock.png'

function SherDineNav() {
	const navigate = useNavigate(null);
	const { clearDineState } = useContext(DineContext);
	const [dateTime, setDateTime] = useState(new Date());
	const [showLogout, setShowLogout] = useState(false);
	// const [user, setUser] = useState([]); // State to store user
    // const [Database, setDatabase] = useState(localStorage.getItem('DB'));
    const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
    const [company, setCompany] = useState(localStorage.getItem('Company'));
	// //(Database,"/n",company);
	const api_base_url = process.env.REACT_APP_API_BASE_URL

	const { logginedDB , customerCode , user , getName , sideNavState , companyDetails , sideNavStateFunc , notification , setNotification, logout } = useContext(DBContext);
	// console.log(companyDetails, "SherDineNav companyDetails");
	
	// //(user);
	
	
	// useEffect(() => {
	// 	fetch(`${api_base_url}/GetUser/${logginedDB}`)
	// 		.then((response) => response.json())
	// 		.then((userData) => {
	// 			setUser(userData); // Set the fetched user in state
	// 		})
	// 		.catch((error) => console.error("Error fetching user:", error));
	// }, []);

	const [events,setEvents] = useState([])

	// console.log('events',events);
	

	const handleGetEvents = async () => {
		try {
			const response = await axios.get(`${api_base_url}/getEvents/${logginedDB}`)
			if (response.status == 200) {
				// console.log(response.data);
				
				const data = response.data
				setEvents(data);
			}
		} catch (error) {
			console.log(error);
			
		}
	}

	const handleGetEventsCount = async () => {
		try {
			const response = await axios.get(`${api_base_url}/getEventsCount/${logginedDB}`)
			if (response.status == 200) {
				// console.log(response.data);
				
				const count = response.data.count
				setNotificationCount(count);
			}
		} catch (error) {
			console.log(error);
			
		}
	}

	// useEffect(() => {
    //     if (logginedDB) {
    //         handleGetEvents()
	// 		handleGetEventsCount()
    //     }
    //     // Connect to the WebSocket server
    //     const socket = io(api_base_url);
    //     socket.on('createdItem', () => {
    //         //('Data updated, fetching new data...');
    //         handleGetEvents();
	// 		handleGetEventsCount()
    //     });
 
    //     return () => {
    //         socket.disconnect();
    //     };
    // }, [api_base_url,logginedDB]);


	  const socketRef = useRef(null);
	
			useEffect(() => {
			  if (!logginedDB) return; // if not logged in, skip
		  
			  // connect socket
			  socketRef.current = io(api_base_url, {
				transports: ["websocket"], // faster than polling
			  });
		  
			  // make sure old listeners are removed before adding new ones
			  socketRef.current
				.off("createdItem")
				.on("createdItem",    handleGetEvents(), handleGetEventsCount());
		  
			
			  // cleanup on unmount
			  return () => {
				socketRef.current.disconnect();
			  };
			}, [api_base_url, logginedDB]);

	useEffect(() => {
		getName()
		const intervalId = setInterval(() => {
			setDateTime(new Date());
		}, 1000);
		return () => clearInterval(intervalId);
	}, []);

	// const formattedDateTime = dateTime.toLocaleString();
    const formattedDateTime = new Intl.DateTimeFormat('en-GB', {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }).format(dateTime);
    

	const handleLogout = () => {
		logout();
		clearDineState();
		navigate("/");
	};

	const toggleLogoutSection = () => {
		setShowLogout((prevShowLogout) => !prevShowLogout);
	};

	const handleSideNavState = () => {
		sideNavStateFunc(sideNavState)
	}

	// const userName = user.length > 0 ? user[0].userFullName : "";
	// const users = userName.split(" ", [1]);
	// //(users);


	const [notificationCount,setNotificationCount] = useState(0)

	const HandleClearEvent = async (e,id) => {
		e.stopPropagation()
		try {
			const response = await axios.post(`${api_base_url}/clearEvents/${logginedDB}/${id}`)
			if (response.status == 200) {

			}
		} catch (error) {
			console.log(error);
		}
	}

	const handleMarkAsRead = async () =>{
		try {
			const response = await axios.post(`${api_base_url}/readAllEvents/${logginedDB}`)
			if (response.status == 200) {

			}
		} catch (error) {
			console.log(error);
		}
	}

	const handleViewed = async (id) =>{
		try {
			const response = await axios.post(`${api_base_url}/readEvent/${logginedDB}/${id}`)
			if (response.status == 200) {

			}
		} catch (error) {
			console.log(error);
		}
	}

	return (
		// <div className="h-max w-full flex">
		<div className="relative w-full flex bg-[#FAFAFA] sticky top-0 z-[9999] p-3 text-nowrap">
			<div className="w-full flex justify-start items-center gap-2">
				<div className="w-max h-max flex flex-col gap-[.3rem] cursor-pointer relative" onClick={handleSideNavState}>
					<div className={`w-[1.75rem] bg-[#464255] rounded-[1rem] transition-transform duration-300 ${sideNavState ? 'absolute transform rotate-[135deg] h-[.225rem]' : 'h-[.2rem]'}`}></div>
					<div className={`w-[1.75rem] bg-[#464255] h-[.2rem] rounded-[1rem] transition-all duration-300 ${sideNavState ? 'hidden' : 'block'}`}></div>
					<div className={`w-[1.75rem] bg-[#464255] rounded-[1rem] transition-transform duration-300 ${sideNavState ? 'transform rotate-[-135deg] h-[.225rem]' : 'h-[.2rem]'}`}></div>
				</div>
				<span className="TitleText_Table cursor-default" onClick={() => navigate('/')}>SherDine</span>
			</div>
            {/* <div className="justaDiv">
            </div> */}
			{/* <div className="DateTime">
				<div>{formattedDateTime}</div>
			</div> */}
      		<div className="w-max flex justify-center items-center gap-3">
					{/* <img
						src={u}
						alt="User"
						className="userImg"
						onClick={toggleLogoutSection}
					/>
					{showLogout && (
						<div className="logoutSection">
							<span className="username">{user}</span>
							<button onClick={handleLogout} className="logoutButton">
                                <div>
                                    <img src={logoutImg} alt="Logout" className="logoutImg" />
                                </div>
                            </button>
						</div>
					)} */}
				<div className="w-[20rem] h-full flex justify-end items-center gap-3">
					<div className="relative flex justify-center items-center" onClick={() => setNotification(a => !a)}>
						<img className="w-[2rem] cursor-pointer" src={notifi} alt="" />
						{notificationCount > 0 && (
							<div className="absolute top-0 right-0 transform translate-x-1/3 -translate-y-1/3 bg-[#0008B4] h-[1rem] min-w-[1rem] max-w-[1.5rem] p-1 flex justify-center items-center text-[.7rem] text-[#F3F2F7] font-poppins rounded-full cursor-pointer">{notificationCount}</div>
						)}
					</div>
					<div className="relative flex justify-center items-center">
						<img className="w-[2rem] cursor-pointer" src={settings} alt="" />
						<div className="absolute top-0 right-0 transform translate-x-1/3 -translate-y-1/3 bg-[#FF5B5B] h-[1rem] min-w-[1rem] max-w-[1.5rem] p-1 flex justify-center items-center text-[.7rem] text-[#F3F2F7] font-poppins rounded-full cursor-pointer">0</div>
					</div>
				</div>
				<div className="w-[18rem] h-full flex justify-end items-center gap-3 border-l-2">
					<span className="text-[#464255] font-poppins text-[1rem] font-semibold mt-[.1rem]"><span className="font-[500]">Hello,&nbsp;</span>{user && user.toUpperCase()}</span>
					<div className="flex justify-center items-center rounded-full w-[2rem] h-[2rem] overflow-hidden">
						<img
							src={companyDetails?.img || u}
							alt="?"
							className="w-full h-full object-cover"
						/>
					</div>
				</div>
			</div>
			{notification && (
				<div className="absolute right-0 transform translate-y-[3rem] overflow-hidden rounded-l-md bg-[#f5f5f5] p-2 shadow-[1px_1px_6px_rgba(0,0,0,0.5)]">
					<div className="bg-[#fff] min-w-[20rem] max-w-[25rem] min-h-0 max-h-[30rem] rounded-md p-3 flex flex-col gap-2 customScroll overflow-auto">
						<div className="w-full h-max flex">
							<span className="w-full flex font-semibold">NOTIFICATIONS</span>
							{notificationCount > 0 && (
								<button className="w-max text-[.8rem] p-[.2rem] rounded-sm text-[#4d4d4d] hover:underline" onClick={handleMarkAsRead}>Mark all as read</button>
							)}
						</div>
						<div className="w-full h-full flex flex-col">
							{events.length > 0 ? events.map((event,index) => {
								const item = event.Category
								const imgg = item && event.Img ? `${api_base_url}/uploads/${customerCode}/${logginedDB}/items/${event.Img}` : null

								let form;

								if (event.FormName === 'ProductReg') {
									form = 'product'
								} else if (event.FormName === 'Category_reg') {
									form = 'category'
								} else if (event.FormName === 'KitchenReg') {
									form = 'kitchen'
								}

								// Parse the date part from DDate
								const eventDate = new Date(event.DDate);

								// Parse the time part from TTime (12-hour format)
								const timeMatch = event.TTime.match(/(\d+):(\d+) (\w+)/);
								if (timeMatch) {
									let [_, hours, minutes, period] = timeMatch;
									hours = parseInt(hours, 10);
									minutes = parseInt(minutes, 10);

									// Convert to 24-hour format
									if (period === "PM" && hours !== 12) {
										hours += 12;
									} else if (period === "AM" && hours === 12) {
										hours = 0;
									}

									eventDate.setHours(hours, minutes, 0, 0); // Set time
								} else {
									console.error("Invalid time format:", event.TTime);
								}

								// Get current time
								const currentTime = new Date();
								const timeDiff = Math.floor((currentTime - eventDate) / 1000); // Convert milliseconds to seconds

								let timeAgo;
								if (timeDiff < 60) {
									timeAgo = `${timeDiff} sec ago`;
								} else if (timeDiff < 3600) {
									timeAgo = `${Math.floor(timeDiff / 60)} min`;
								} else if (timeDiff < 86400) {
									timeAgo = `${Math.floor(timeDiff / 3600)} hr`;
								} else if (timeDiff < 604800) { // Less than a week
									timeAgo = `${Math.floor(timeDiff / 86400)} days`;
								} else if (timeDiff < 2419200) { // Less than a month (assuming 4 weeks)
									timeAgo = `${Math.floor(timeDiff / 604800)} weeks`;
								} else if (timeDiff < 29030400) { // Less than a year (assuming 12 months)
									timeAgo = `${Math.floor(timeDiff / 2419200)} months`;
								} else {
									timeAgo = `${Math.floor(timeDiff / 29030400)} years`;
								}

								return (
									<div className="relative w-full h-full flex border-b py-1" key={index} onClick={() => handleViewed(event.Auto)}>
										{event.IsViewed !== 1 && (
											<div className="absolute left-0 top-1 rounded-full p-1 bg-[#0008B4] bg-opacity-75"></div>
										)}
										<div className="w-max h-full flex justify-start items-start pr-3 pt-1">
											<div className={`w-[2rem] h-[2rem] flex justify-center bg-[#4b51be] bg-opacity-25 items-center rounded-md ${form === 'product' ? 'p-[.1rem]' : ' p-1'}`}>
												<img className="w-full h-full rounded-md" src={(item && imgg) ? imgg : form === 'product' ? noImage : stock} alt=""/>
											</div>
										</div>
										<div className="w-full h-full flex flex-col text-[#827e9a] gap-1 text-[.9rem]">
											<span className="w-full h-full text-wrap"><span className="font-semibold text-[#4d4b5c]">{event.Name} &nbsp;</span>{event.Description}</span>
											<div className="w-full flex justify-center items-center">
												<span className="w-full h-max flex justify-start items-center gap-1 text-[.8rem]"><img className="w-[.75rem] opacity-75" src={clock} alt=""/>{timeAgo}</span>
												<span className="w-max text-[.8rem] p-[.2rem] rounded-sm text-[#0008B4] hover:underline cursor-pointer" onClick={(e) => HandleClearEvent(e,event.Auto)}>clear</span>
											</div>
										</div>
									</div>
								)
							}) : (
								<div className="text-wrap text-[.85rem] text-[#706e6e]">No new notifications!</div>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default SherDineNav;
